<script setup lang="ts">
import {ref} from "vue";
import {useClipboard} from "@vueuse/core";

interface Props {
    text: string
    size?: 'small' | 'medium' | 'large'
}
const props = withDefaults(defineProps<Props>(), {
    size: 'small'
})
const emit = defineEmits(['copied'])
const { copy, isSupported } = useClipboard()
const isShown = ref(false)
const randomId = Math.random().toString(36).substring(7)

const copyToClipboard = () => {
    copy(props.text)
    isShown.value = true
    emit('copied')
    setTimeout(() => {
        isShown.value = false
    }, 3000)
}
</script>

<template>
    <v-tooltip
        v-if="isSupported"
        :model-value="true"
        location="end"
        :activator="`#copy-btn-${randomId}`"
        offset="5"
        :class="isShown ? null : 'hidden'"
    >
        <template #activator>
            <v-btn
                :id="`copy-btn-${randomId}`"
                variant="plain"
                :size="props.size"
                :color="isShown ? 'success' : 'primary'"
                class="text-body-2 mx-1"
                @click="copyToClipboard"
            >
                <v-icon>
                    {{ isShown ? 'mdi-check' : 'mdi-content-copy' }}
                </v-icon>
            </v-btn>
        </template>
        Copied!
    </v-tooltip>
</template>

<style scoped>
.hidden {
    display: none;
}
</style>
